import axios from '../axios'

export const selectPropaganda = params => {
    return axios({
        url: '/v1/propaganda',
        method: 'get',
        params
    })
};

export const deletePropaganda = propagandaId => {
    return axios({
        url: '/v1/propaganda/'+ propagandaId,
        method: 'delete'
    })
};